import React from "react";
import { TextTypeInputProps } from "./text-type-input.props";
import "./text-type-input.styles.scss";

export const TextTypeInput: React.FC<TextTypeInputProps> = (props) => {
    // remove whitespace for ID
    const sanitizedId = props.id
        .replace(/ /g, "");

    let inputAttributes: any = {
        id: sanitizedId,
        placeholder: props.label,
    }

    // For textarea, we don't use 'type' prop
    if (props.type !== "textarea") {
        inputAttributes.type = props.type ?? "text";
    }

    if (props.readonly) {
        inputAttributes = {
            ...inputAttributes,
            ...{
                readOnly: true,
                tabIndex: -1
            }
        }
    }

    // wire up our input to react-hook-form
    // https://react-hook-form.com/get-started
    if (props.registerHook) {
        if (props.registerOptions) {
            inputAttributes = {
                ...inputAttributes,
                ...props.registerHook(sanitizedId, props.registerOptions),
                ...(props.registerOptions.maxLength && { maxLength: props.registerOptions.maxLength }),
                ...(props.registerOptions.value && { value: props.registerOptions.value })
            };
        } else {
            inputAttributes = {
                ...inputAttributes,
                ...props.registerHook(sanitizedId)
            };
        }
    }

    // Determine if we should render textarea or input
    const isTextarea = props.type === "textarea";

    return (
        <div className={`text-type-container ${props.className}`}>
            <div className="flex justify-between mb-1">
                {(props.label && !props.hideLabel) &&
                    <label htmlFor={sanitizedId}>
                        {props.label}
                    </label>
                }
                {props.labelRight &&
                    <span className={props.labelRightClassName ? props.labelRightClassName : "label-right"}>
                        {props.labelRight}
                    </span>
                }
            </div>

            {props.errorState &&
                <span className="error-style" role="alert">
                    {`${props.errorState.message}`}
                </span>
            }
            {isTextarea ? (
                <textarea
                    {...inputAttributes}
                    className={`${props.errorState && "field-error"} ${props.inputClassName}`}
                    aria-invalid={props.errorState ? "true" : "false"}
                    data-testid="input-test"
                    style={props.style}
                    rows={props.rows || 3}
                    cols={props.cols}
                />
            ) : (
                <input
                    {...inputAttributes}
                    className={`${props.errorState && "field-error"} ${props.inputClassName}`}
                    aria-invalid={props.errorState ? "true" : "false"}
                    data-testid="input-test"
                    style={props.style}
                />
            )}
        </div>
    )
};